import { styled } from '@mui/material/styles'
import React from 'react'
import { BooleanInput, DateInput, SimpleForm, TextInput } from 'react-admin'
import { CustomFormProps } from 'types/common'
import Kdivider from 'ui-shared/LayoutComponents/Kdivider'
import KNumberInput from 'ui-shared/WrappedInputs/KNumberInput'

const PREFIX = 'CouponForm'

const classes = {
  inline: `${PREFIX}-inline`,
  grow: `${PREFIX}-grow`,
  hide: `${PREFIX}-hide`,
  sectionTitle: `${PREFIX}-sectionTitle`,
  divider: `${PREFIX}-divider`,
  productFieldsContainer: `${PREFIX}-productFieldsContainer`,
  fullWidth: `${PREFIX}-fullWidth`,
  mt: `${PREFIX}-mt`,
}

const StyledSimpleForm = styled(SimpleForm)(({ theme }: any) => ({
  [`& .${classes.inline}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
  },

  [`& .${classes.grow}`]: { flexGrow: 1 },

  [`& .${classes.hide}`]: {
    height: '0px',
    width: '0px',
    visibility: 'hidden',
  },

  [`& .${classes.sectionTitle}`]: {
    fontWeight: 'bold',
    fontSize: '20px',
    marginTop: '4px',
  },

  [`& .${classes.divider}`]: {
    width: '100%',
    height: '3px',
    backgroundColor: theme.palette.primary.light,
    marginTop: '20px',
  },

  [`& .${classes.productFieldsContainer}`]: {
    width: '48%',
    display: 'flex',
    flexDirection: 'column',
  },

  [`& .${classes.fullWidth}`]: {
    width: '100%',
  },

  [`& .${classes.mt}`]: {
    marginTop: '24px',
  },
}))

const CouponForm: React.FC<CustomFormProps> = (props) => {
  return (
    <StyledSimpleForm {...props}>
      <div className={classes.inline}>
        <div className={classes.productFieldsContainer}>
          <TextInput source="name" label="Name" required />
          <TextInput source="code" label="Coupon Code" required />
          <DateInput source="startDate" label="Valid From" required />
          <DateInput source="endDate" label="Valid Until" required />
        </div>
        <div className={classes.productFieldsContainer}>
          <BooleanInput source="enabled" />
          <BooleanInput source="oncePerUser" />
        </div>
      </div>
      <Kdivider />
      <div className={`${classes.inline} ${classes.mt}`}>
        <KNumberInput
          source="discountPerc"
          label="Percentage Discount"
          required
        />
        <KNumberInput
          source="cartMinimumAmount"
          label="Minimum Amount"
          required
        />
      </div>
    </StyledSimpleForm>
  )
}

export default CouponForm
